import React from 'react';
import { Link } from 'react-router-dom';

export default function TenantNotFound({ slug, canRetry }) {
  return (
    <div className="min-h-screen bg-[#F5F3EF] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-8xl font-black text-[#2C3E2D]" style={{ fontFamily: 'Chivo, sans-serif' }}>
            404
          </h1>
          <div className="w-24 h-1 bg-[#D4A55A] mx-auto mt-4"></div>
        </div>
        
        <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Store Not Found
        </h2>
        
        <p className="text-[#5A6B5C] mb-8">
          {canRetry
            ? <>We couldn't connect just now. This is usually temporary — try reloading the page.</>
            : <>The store <span className="font-semibold text-[#2C3E2D]">"{slug}"</span> doesn't exist or is no longer available.</>
          }
        </p>
        
        <div className="space-y-4">
          {canRetry && (
            <button
              onClick={() => window.location.reload()}
              className="inline-block h-12 px-8 bg-[#4A6741] text-white font-bold uppercase tracking-wider rounded-lg hover:bg-[#3A5733] transition-all w-full"
              data-testid="tenant-not-found-retry-button"
            >
              Try Again
            </button>
          )}
          <p className="text-sm text-[#5A6B5C]">
            Please check the URL and try again, or visit our homepage:
          </p>
          
          <Link 
            to="/"
            className="inline-block h-12 px-8 bg-[#4A6741] text-white font-bold uppercase tracking-wider rounded-lg hover:bg-[#3A5733] transition-all flex items-center justify-center"
            data-testid="tenant-not-found-home-link"
          >
            Go to Homepage
          </Link>
        </div>
        
        <div className="mt-12 pt-8 border-t border-[#E8E4DC]">
          <p className="text-xs text-[#5A6B5C]">
            If you believe this is an error, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
}
